import { useEffect, useState } from 'react';
import axios from 'axios';
import { BASE_URL } from '../constants/config';
import { matchesAnyName } from '../utils/practitionerNames';

// Names of practitioners who have a SimplePractice calendar. Names only — the
// links themselves never reach the browser until a visitor passes Turnstile.
// Fetched once per page load and shared by every card/profile that asks.
let cache = null;
let inFlight = null;
const subscribers = new Set();

const fetchNames = () => {
  if (cache) return Promise.resolve(cache);
  if (!inFlight) {
    inFlight = axios
      .get(`${BASE_URL}/simple-practice/practitioners`)
      .then((r) => {
        cache = Array.isArray(r.data?.practitioners) ? r.data.practitioners : [];
        return cache;
      })
      .catch(() => {
        // Booking buttons stay hidden rather than leading to a dead end.
        cache = [];
        return cache;
      })
      .finally(() => {
        inFlight = null;
        subscribers.forEach((notify) => notify(cache));
      });
  }
  return inFlight;
};

export const useBookablePractitioners = () => {
  const [names, setNames] = useState(cache || []);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    if (cache) return undefined;
    let alive = true;
    const notify = (value) => {
      if (!alive) return;
      setNames(value);
      setLoading(false);
    };
    subscribers.add(notify);
    fetchNames().then(notify);
    return () => {
      alive = false;
      subscribers.delete(notify);
    };
  }, []);

  return {
    loading,
    // While the list is loading the button stays hidden: showing it and then
    // pulling it away is worse than showing it a moment later.
    isBookable: (practitionerName) => matchesAnyName(practitionerName, names),
  };
};
